import { User } from "..";
import { SessionStatus } from "../enumerations";

export class LoginSession {
	public static readonly $type: string = "LoginSession";
	public readonly $type: string = LoginSession.$type;

	public status!: SessionStatus;
	public startedAt!: Date;
	public expiresAt!: Date;
	public endedAt?: Date;
	public user!: User;
}
